import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressIsLastOrderState = boolean;

const initialState: ContractProgressIsLastOrderState = false;

export default function reducer(
  state: ContractProgressIsLastOrderState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    case CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS:
      return action.payload.isLastOrder;
    default:
      return state;
  }
}
